import React from 'react';
import './header.css';
import CTA from './CTA';
import ReignB from '../../acesset/ReignB.png';
import HeaderScocial from './HeaderScocial';
import { GradientText } from '../reactbits';

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <div className="header__content">
          <span className="header__badge">Senior Full-Stack Engineer</span>
          <h5>Building Production-Grade Software</h5>
          <GradientText as="h1">Sadiq Haruna</GradientText>
          <p className='header__tagline'>
            I built <span className="highlight">scalable healthcare systems</span> and <span className="highlight">enterprise solutions</span> that solve real-world problems for governments, institutions, and startups.
          </p>
          
          {/* <ScrollReveal direction="up" delay={0.3}>
            <div className="header__stats">
              <div className="stat-item">
                <h3><CountUp end={4} suffix="+" /></h3>
                <p>Years Experience</p>
              </div>
              <div className="stat-item">
                <h3><CountUp end={38} suffix="+" /></h3>
                <p>Projects Delivered</p>
              </div>
              <div className="stat-item">
                <h3><CountUp end={25} suffix="+" /></h3>
                <p>Global Clients</p>
              </div>
            </div>
          </ScrollReveal> */}

          <CTA />
        </div>

        <HeaderScocial />

        <div className='me'>
          <img src={ReignB} alt='Sadiq Haruna - Full-Stack Engineer' />
        </div>

        <a href='#contact' className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  );
};

export default Header;
